import React from 'react';
import { Link } from 'react-router-dom';
import Logo from "../Logo";

import styles from './Footer.module.css';

const Footer: React.FC = () => {
    return (
        <footer className={styles.footer} role="contentinfo">
            <div className={styles.inner}>
                <div className={styles.contacts}>
                    <div>
                        <a href="tel:+78007001166" className={styles.phoneLink}>8 800 700-11-66</a>
                    </div>
                    <div>
                        <a href="mailto:train_support@tourbytrain.com" className={styles.link}>
                            train_support@tourbytrain.com
                        </a>
                    </div>
                </div>
                <div className={styles.logo}><Logo /></div>
                <Link to="/legal" className={styles.link}>Legal information</Link>
            </div>
        </footer>
    );
};

export default Footer;
